import request from '../request';

/** @name 获取【烤箱文件】访问oss地址 */
export function getAuth(data) {
  return request(`/oss/iot/oss/getAuth`, {
    method: 'POST',
    body: data,
  });
}
